// extracted by mini-css-extract-plugin
export default {"row":"PolicyTermControls_row__UBiuD","label":"PolicyTermControls_label__zH3cr"};